import { Button } from '@kerfjs/ui/button';
import { EmptyState } from '@kerfjs/ui/empty-state';
import { List } from '@kerfjs/ui/list';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { libraryProjects, libraryScope } from '../../../data/state.js';

/**
 * Project › Info (HS2-91S2YF): the basic details of the project selected in the
 * project tab bar. Name and description save on blur. Project › Knowledge Base
 * renders the library view instead.
 */
export function ProjectSettingsView(): SafeHtml {
  const project = libraryProjects.value.find((candidate) => candidate.id === libraryScope.value);
  return (
    <section class="project-settings-view">
      {project === undefined ? (
        <EmptyState
          title="No Projects Yet"
          detail="Create a project to keep its Knowledge Base and demands together."
          action={
            <Button size="default" tone="brand" emphasis="primary" action="lib-new-project">
              Create Your First Project…
            </Button>
          }
        />
      ) : (
        <List gap="m" controlInsets="rl" rootAttributes={{ 'data-key': project.id }}>
          <TextField
            type="text"
            name="project-name"
            label="Name"
            value={project.name}
            rootAttributes={{ 'data-action': 'project-info-name' }}
          />
          <TextField
            multiline
            name="project-description"
            label="Description"
            rows={3}
            value={project.description ?? ''}
            rootAttributes={{ 'data-action': 'project-info-description' }}
          />
        </List>
      )}
    </section>
  );
}
